// extracted by mini-css-extract-plugin
export default {"span":"Link_span__VMnl5","linkColor":"Link_linkColor__WrP-f"};